/**
 * Run lifecycle helper — shared, VIEWER-INDEPENDENT.
 *
 * Mirrors the product contract for how a run should be presented regardless of
 * who is looking at it. CTA decisions (host vs player, joined, etc.) live in the
 * individual components — this helper only classifies the run.
 *
 * Precedence (highest first):
 *   1. cancelled          — status cancelled/canceled
 *   2. completed          — status completed OR an outcome was recorded
 *   3. awaiting_outcome   — scheduled start is in the past, not cancelled/completed
 *   4. active             — everything else
 *
 * Do NOT pass isHost / isJoined / any viewer-specific field into this helper.
 */
import { isPastRun } from './datetime';

export const RUN_LIFECYCLE = {
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  AWAITING_OUTCOME: 'awaiting_outcome',
  ACTIVE: 'active',
};

export const deriveRunLifecycle = ({
  status,
  date_time,
  completion_status,
  result_winner,
} = {}) => {
  // 1. Cancelled wins first.
  if (status === 'cancelled' || status === 'canceled') {
    return RUN_LIFECYCLE.CANCELLED;
  }
  // 2. Completed wins second. Degrades gracefully where completion_status /
  //    result_winner are not present (e.g. RunPreview only exposes `status`).
  if (status === 'completed' || completion_status || result_winner) {
    return RUN_LIFECYCLE.COMPLETED;
  }
  // 3. Past but not cancelled/completed -> awaiting outcome.
  if (isPastRun(date_time)) {
    return RUN_LIFECYCLE.AWAITING_OUTCOME;
  }
  // 4. Otherwise active.
  return RUN_LIFECYCLE.ACTIVE;
};
